<template lang="pug">
.cell(:class="cellClasses")
  .cell__content
    .cell__date {{ dayOfMonth }}
    .cell__counter(v-if="numberOfEvents > 0" :class="{ 'cell__counter--selected': isSelected }") {{ numberOfEvents }}
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import moment from '@/common/AppMoment.js'

export default {
  props: {
    date: String
  },

  computed: {
    ...mapState('event', ['period', 'selectedDate', 'events']),
    ...mapGetters('event', ['filteredEvents']),

    numberOfEvents () {
      return this.filteredEvents.filter(ev => moment(ev.eventDate).isSame(this.date, 'day')).length
    },

    dayOfMonth () {
      return moment(this.date).date()
    },

    cellClasses () {
      return {
        'cell--selected': this.isSelected,
        'cell--today': this.isToday,
        'cell--another-month': this.isAnotherMonth,
        'cell--is-past-days': this.isPastDaysOfMonth,
        'cell--weekend': this.isWeekend && !this.isSelected && !this.isAnotherMonth
      }
    },

    isSelected () {
      return this.selectedDate ? moment(this.selectedDate).isSame(this.date, 'day') : false
    },

    isToday () {
      return moment().isSame(this.date, 'day')
    },

    isAnotherMonth () {
      return moment(this.period.date).isSame(this.date, 'month') == false
    },

    isPastDaysOfMonth () {
      return !this.isAnotherMonth && moment().isAfter(this.date, 'day')
    },

    isWeekend () {
      return moment(this.date).weekday() > 4 // 0 - Пн,.. 4 - Пт
    },
  }
}
</script>

<style lang="scss" scoped>
.cell {
  border-radius: 5px;
  background-color: #FFFFFF;
  border: 1px solid #FFFFFF;
  color: #505254;

  &:hover {
    border: 2px solid #505254;
  }

  // Модификаторы
  &--selected {
    border: 5px solid #00BCD4 !important;
  }

  &--today {
    background-color: #1B93AD;
    border: 1px solid #1B93AD;
    color: #FFFFFF !important;
  }

  &--another-month {
    background-color: #505254;
    border: 1px solid #959595;
    color: #757575;
  }

  &--is-past-days {
    background-color: #E1F3F5;
    border: 1px solid #E1F3F5;
  }

  &--weekend {
    color: #959595;
  }

  // Элементы
  &__content {
    position: relative;
    padding-top: 100%;
  }

  &__date {
    position: absolute;
    top: 10%;
    left: 15%;

    font: 24px/18px Roboto Slab;
    font: 1.8vw Roboto Slab;
  }
}

.cell__counter {
  $size: 1.6vw;
  
  position: absolute;
  right: 15%;
  bottom: 10%;

  min-width: 20px;
  min-width: $size;

  border-radius: 10px;
  border-radius: $size/2;
  
  font: 12px/20px Roboto Condensed;
  font: bold calc(0.6 * #{$size})/$size Roboto Condensed;

  text-align: center;

  color: #000000;
  background-color: #C4C4C4;

  &--selected {
    color: #FFFFFF;
    background-color: #00BCD4;
  }
}
</style>